import React from 'react';
import StyleSheet from 'react-native-extended-stylesheet';
import Animated, {useAnimatedStyle, withRepeat, withSequence, withTiming, Easing} from 'react-native-reanimated';
import {View, Theme} from '@lookiero/aurora';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
});

const {
  colorBgPrimaryMedium: bgMedium,
  colorBgPrimaryMediumLight: bgMediumLight,
  colorBgPrimaryLight: bgLight,
} = Theme.get();

interface LoadingDotsProps {
  size?: number;
}

const LoadingDots: React.FC<LoadingDotsProps> = ({size = 8} = {}) => {
  const animation1 = useAnimatedStyle(
    () => ({
      backgroundColor: withRepeat(
        withSequence(
          withTiming(bgMedium, {duration: 0, easing: Easing.linear}),
          withTiming(bgMedium, {duration: 300, easing: Easing.linear}),
          withTiming(bgLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgMediumLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgMedium, {duration: 300, easing: Easing.linear}),
          withTiming(bgMedium, {duration: 300, easing: Easing.linear}),
          withTiming(bgMedium, {duration: 300, easing: Easing.linear}),
        ),
        -1,
      ),
      transform: [
        {
          translateY: withRepeat(
            withSequence(
              withTiming(0, {duration: 0, easing: Easing.linear}),
              withTiming(-(size / 2), {duration: 300, easing: Easing.linear}),
              withTiming(-size, {duration: 300, easing: Easing.linear}),
              withTiming(-(size / 2), {duration: 300, easing: Easing.linear}),
              withTiming(0, {duration: 300, easing: Easing.linear}),
              withTiming(0, {duration: 300, easing: Easing.linear}),
              withTiming(0, {duration: 300, easing: Easing.linear}),
            ),
            -1,
          ),
        },
      ],
    }),
    [size],
  );

  const animation2 = useAnimatedStyle(
    () => ({
      backgroundColor: withRepeat(
        withSequence(
          withTiming(bgMediumLight, {duration: 0, easing: Easing.linear}),
          withTiming(bgMediumLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgMedium, {duration: 300, easing: Easing.linear}),
          withTiming(bgLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgMediumLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgMediumLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgMediumLight, {duration: 300, easing: Easing.linear}),
        ),
        -1,
      ),
      transform: [
        {
          translateY: withRepeat(
            withSequence(
              withTiming(0, {duration: 0, easing: Easing.linear}),
              withTiming(0, {duration: 300, easing: Easing.linear}),
              withTiming(-(size / 2), {duration: 300, easing: Easing.linear}),
              withTiming(-size, {duration: 300, easing: Easing.linear}),
              withTiming(-(size / 2), {duration: 300, easing: Easing.linear}),
              withTiming(0, {duration: 300, easing: Easing.linear}),
              withTiming(0, {duration: 300, easing: Easing.linear}),
            ),
            -1,
          ),
        },
      ],
    }),
    [size],
  );

  const animation3 = useAnimatedStyle(
    () => ({
      backgroundColor: withRepeat(
        withSequence(
          withTiming(bgLight, {duration: 0, easing: Easing.linear}),
          withTiming(bgLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgMediumLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgMedium, {duration: 300, easing: Easing.linear}),
          withTiming(bgLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgLight, {duration: 300, easing: Easing.linear}),
          withTiming(bgLight, {duration: 300, easing: Easing.linear}),
        ),
        -1,
      ),
      transform: [
        {
          translateY: withRepeat(
            withSequence(
              withTiming(0, {duration: 0, easing: Easing.linear}),
              withTiming(0, {duration: 300, easing: Easing.linear}),
              withTiming(0, {duration: 300, easing: Easing.linear}),
              withTiming(-(size / 2), {duration: 300, easing: Easing.linear}),
              withTiming(-size, {duration: 300, easing: Easing.linear}),
              withTiming(-(size / 2), {duration: 300, easing: Easing.linear}),
              withTiming(0, {duration: 300, easing: Easing.linear}),
            ),
            -1,
          ),
        },
      ],
    }),
    [size],
  );

  const styleContainer = {height: size * 2};
  const styleDot = {height: size, width: size, borderRadius: size / 2};
  const styleGap = {marginRight: size / 2};

  return (
    <View style={[styles.container, styleContainer]}>
      <Animated.View style={[animation1, styleDot, styleGap]} />
      <Animated.View style={[animation2, styleDot, styleGap]} />
      <Animated.View style={[animation3, styleDot]} />
    </View>
  );
};

export {LoadingDots};
